<div class="contenedor-principal" *ngIf="datosRecibidos && errorMessage === ''">
    <div class="caja-establecimientos" routerLink="/establecimientos">
        <h2 class="titulo-establecimientos"><i class="material-icons icono-establecimiento">store</i>ESTABLECIMIENTOS</h2>
        <div class="contenido-establecimientos">
            <span class="numero-establecimientos">{{ nEstablecimientos }}</span>
        </div>
    </div>

    <div class="caja-alarmas">
        <h2 class="titulo-alarmas" [routerLink]="['/alarmas/activas']"><i class="material-icons icono-establecimiento">warning</i>
            <span class="numero-alarmas">{{ nAlarmasSinPresion }}</span> ALARMAS ACTIVAS
        </h2>
        <div class="contenido-alarmas">
            <div class="contenedor-boton">
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 1 }">
                    <i class="material-icons">local_drink</i>
                    <div class="alarma-texto">
                        <span>NIVEL</span>
                        <span class="contador-valor">{{ contadorAlarmaNivel }}</span>
                    </div>            
                </button>
                <span  *ngIf="(userData.pro_id == 4 || userData.pro_id == 2 || userData.pro_id == 1) && establecimientosConAlarmasNivel.length !== 0" class="icono-circular" (click)="abrirDialogoRecargas('400ms','200ms'); $event.stopPropagation()">
                    <mat-icon class="icon-icono-circular">autorenew</mat-icon>
                </span>
            </div>
            <div>
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 2 }">
                    <i class="material-icons">thermostat</i>
                    <div class="alarma-texto">
                        <span>TEMPERATURA</span>
                        <span class="contador-valor">{{ contadorAlarmaTemperatura }}</span>
                    </div>
                </button>
            </div>
            <div>
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 3 }">
                    <i class="material-icons">wifi</i>
                    <div class="alarma-texto">
                        <span>CONEXIÓN</span>
                        <span class="contador-valor">{{ contadorAlarmaConexion }}</span>
                    </div>
                </button>
            </div>
            <div>
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 4 }">
                    <div class="alarma-texto">
                        <span><i class="material-icons">insert_chart</i>HARDWARE</span>
                        <span class="contador-valor">{{ contadorOtras }}</span>
                    </div>
                </button>
            </div>
        </div>        
    </div>
</div>

<div *ngIf="datosRecibidos">
    <div class="titulo-consumos">
        <img class="icono" src="assets\images\beer-icon.png">
        <label>CONSUMOS TOTALES</label>
    </div>    
</div>

<div *ngIf="datosRecibidos" class="cards">
    <mat-card class="style-cards" (click)="openDialog('400ms', '200ms', consumoDiaActualPorTipo);$event.stopPropagation()">
        <mat-card-title class="card-title">
            <!-- <img class="home-img" src="assets\images\beer-icon.png"> -->
            Día {{dia}}
        </mat-card-title>
        <mat-card-content class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(consumoDiaActualTotal)}}</span> litro/s</mat-list-item>
            </mat-list>             
        </mat-card-content>
    </mat-card>
    <mat-card class="style-cards2"  (click)="openDialog('400ms', '200ms', consumoMesActualPorTipo);$event.stopPropagation()">
        <mat-card-title class="card-title2">Mes {{nombreMes}}</mat-card-title>
        <mat-card-content class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(consumoMesActualTotal)}}</span> litro/s</mat-list-item>
            </mat-list>              
        </mat-card-content>
    </mat-card>
    <mat-card class="style-cards3"  (click)="openDialog('400ms', '200ms', consumoAnioActualPorTipo);$event.stopPropagation()">
        <mat-card-title class="card-title3">Año {{anio}}</mat-card-title>
        <mat-card-content class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(consumoAnioActualTotal)}}</span> litro/s</mat-list-item>
            </mat-list>           
        </mat-card-content>
    </mat-card>
</div>

<div *ngIf="datosRecibidos">
    <div class="titulo-consumos">
        <img class="icono" src="assets\images\icon-day.png">
        <label>DÍAS DE MAYOR CONSUMO</label>
    </div>    
</div>

<div *ngIf="datosRecibidos"  class="cards">
    <mat-card class="style-cards" (click)="openDialog('400ms', '200ms', maxConsumptionWeekDayDetallado);$event.stopPropagation()">
        <mat-card-title  class="card-title">Semana Actual: {{ maxConsumptionWeekDay?.day ? (maxConsumptionWeekDay.day.charAt(0).toUpperCase() + maxConsumptionWeekDay.day.slice(1) + " " + (maxConsumptionWeekDay.d || "")) : "Sin Datos" }}</mat-card-title>
        <mat-card-content class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(maxConsumptionWeekDay?.total)}}</span> litro/s</mat-list-item>
            </mat-list>           
        </mat-card-content>
    </mat-card>
    <mat-card class="style-cards2" (click)="openDialog('400ms', '200ms', maxConsumptionMonthDayDetallado);$event.stopPropagation()">
        <mat-card-title class="card-title2">Mes {{getNombreMes(maxConsumptionMonthDay?.m)}}: {{ maxConsumptionMonthDay?.day ? (maxConsumptionMonthDay.day.charAt(0).toUpperCase() + maxConsumptionMonthDay.day.slice(1) + " " + (maxConsumptionMonthDay.d || "")) : "Sin Datos" }}</mat-card-title>
        <mat-card-content  class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(maxConsumptionMonthDay?.total)}}</span> litro/s</mat-list-item>
            </mat-list>              
        </mat-card-content>
    </mat-card>
    <mat-card class="style-cards3" (click)="openDialog('400ms', '200ms', maxConsumptionYearDayDetallado);$event.stopPropagation()">
        <mat-card-title class="card-title3">Año {{maxConsumptionYearDay?.y || "Actual"}}: {{ maxConsumptionYearDay?.day && maxConsumptionYearDay?.d && maxConsumptionYearDay?.m 
            ? (maxConsumptionYearDay.day.charAt(0).toUpperCase() + maxConsumptionYearDay.day.slice(1) + 
               " " + maxConsumptionYearDay.d + " de " + getNombreMes(maxConsumptionYearDay.m)) 
            : "Sin Datos" }}</mat-card-title>
        <mat-card-content class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(maxConsumptionYearDay?.total)}}</span> litro/s</mat-list-item>
            </mat-list>           
        </mat-card-content>
    </mat-card>
</div>

<div *ngIf="datosRecibidos">
    <div class="titulo-consumos">
        <img class="icono" src="assets\images\icon-week.png">
        <label>SEMANAS DE MAYOR CONSUMO</label>
    </div>    
</div>

<div *ngIf="datosRecibidos"  class="cards">
    <mat-card class="style-cards" (click)="openDialog('400ms', '200ms', maxConsumptionYearWeekDetallado);$event.stopPropagation()">
        <mat-card-title class="card-title">
            <div class="title-container">
              <span class="main-title">Mes {{getNombreMes(extraerMes(maxConsumptionYearWeek?.weekRange))}}: {{extraerDias(maxConsumptionYearWeek?.weekRange)  || "Sin Datos"}}</span>
            </div>
        </mat-card-title>
        <mat-card-content class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(maxConsumptionYearWeek?.total)}}</span> litro/s</mat-list-item>
            </mat-list>           
        </mat-card-content>
    </mat-card>
    <mat-card class="style-cards2" (click)="openDialog('400ms', '200ms', maxConsumptionMonthWeekDetallado);$event.stopPropagation()">
        <mat-card-title class="card-title2">
            <div class="title-container">
              <span class="main-title">Año {{getExtraerPrimerAnio(maxConsumptionMonthWeek?.weekRange)}}: {{getExtraerDiaMes(maxConsumptionMonthWeek?.weekRange)  || "Sin Datos"}}</span>
            </div>
        </mat-card-title>
        <mat-card-content  class="cardContent">
            <mat-list role="list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(maxConsumptionMonthWeek?.total)}}</span> litro/s</mat-list-item>
            </mat-list>              
        </mat-card-content>
    </mat-card>
    <mat-card class="style-cards3" (click)="openDialog('400ms', '200ms', maxConsumptionPreviusYearWeekDetallado);$event.stopPropagation()">
        <mat-card-title class="card-title3">
            <div class="title-container">
              <span class="main-title">Año {{getExtraerPrimerAnioPasado(maxConsumptionPreviusYearWeek?.weekRange)}}: {{getExtraerDiaMes(maxConsumptionPreviusYearWeek?.weekRange)  || "Sin Datos"}}</span>
            </div>
        </mat-card-title>
        <mat-card-content class="cardContent">
            <mat-list role="list" class="mat-list">
                <mat-list-item role="listitem"><span class="spanListItem">{{formatearConsumo(maxConsumptionPreviusYearWeek?.total)}}</span> litro/s</mat-list-item>
            </mat-list>           
        </mat-card-content>
    </mat-card>
</div>

<div *ngIf="datosRecibidos" class="divider-container">
    <mat-divider></mat-divider>
</div>

<div *ngIf="datosRecibidos && consumosPorHorasCargado">
    <div class="titulo-consumos-primera-grafica">
        <img class="icono" src="assets\images\icon-stacked-bar-edited.png">
        <label>CONSUMO ACUMULADO POR HORA MES ACTUAL</label>
    </div>
    <div class="g-Ranking height400" *ngIf="consumosHorasDatos">
        <button mat-flat-button class="resetZoomButton" (click)="resetZoomConsumos()">
            <img src="assets/images/zoom-out.svg" alt="Zoom Out" class="zoom-icon"/>
        </button>      
        <canvas id="Consumos"></canvas>
    </div>
</div>

<div *ngIf="datosRecibidos && rakingEstablecimientosCambiadaCargarda">
    <div class="titulo-consumos">
        <img class="icono" src="assets\images\icon-stacked-bar.png">
        <label>TOP 10 ESTABLECIMIENTOS MES ACTUAL</label>
    </div>   
    <div class="g-Ranking height400" *ngIf="rankingEstablecimientosDatos">
        <button mat-flat-button class="resetZoomButton" (click)="resetZoomRanking()">
            <img src="assets/images/zoom-out.svg" alt="Zoom Out" class="zoom-icon"/>
          </button>      
        <canvas id="Ranking"></canvas>
    </div>
</div>

<!--CARGAR-->
<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos ...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<!--ERROR-->
<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>